<template>
  <div class="flex flex-col gap-1">
    <div class="text-lg font-bold">
      {{ props.data.DisplayName }}
    </div>
    <div class="text-base">
      {{ props.data.Email }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface AuxInputProps {
  data: unknown;
}

const props = defineProps<AuxInputProps>();
</script>

<style scoped></style>

